export const contentTypeEntries = [
  {
    id: 'entertainment',
    name: '娱乐瓜',
    icon: 'ri-fire-line',
    desc: '综艺幕后 · 片场花絮 · 节目冲突',
    count: 1284,
    badge: '热',
    href: '#fenlei',
  },
  {
    id: 'influencer',
    name: '网红历史',
    icon: 'ri-history-line',
    desc: '直播翻车 · 人设考古 · 账号风云',
    count: 962,
    badge: '新',
    href: '#fenlei',
  },
  {
    id: 'celebrity',
    name: '明星八卦',
    icon: 'ri-star-line',
    desc: '行程同框 · 合作绯闻 · 街拍路透',
    count: 1730,
    badge: '爆',
    href: '#fenlei',
  },
  {
    id: 'citizen',
    name: '素人爆料',
    icon: 'ri-user-voice-line',
    desc: '素人投稿 · 聊天记录 · 现场目击',
    count: 548,
    badge: '荐',
    href: '#fenlei',
  },
];

export const entryQuickTags = [
  '今日新增 37 条',
  '已核实 12 条',
  '待筛选 86 条',
  '视频素材 24 段',
  '聊天记录 61 组',
];